<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Időszaki munka kimutatás</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
<!--            <el-form-item-->
<!--              label="Dátum"-->
<!--            >-->
<!--              <el-date-picker-->
<!--                v-model="dateRange"-->
<!--                type="daterange"-->
<!--                :clearable="false"-->
<!--                format="yyyy. MM. dd."-->
<!--                value-format="yyyy-MM-dd"-->
<!--                :picker-options="dateRangeOptions"-->
<!--                style="margin-right: 10px;"-->
<!--                @change="fetchData"-->
<!--              />-->
<!--            </el-form-item>-->
            <el-form-item
              label="Időszaki munka"
            >
              <el-select
                v-model="task"
                filterable
                :loading="taskLoading"
                style="width: 100%;"
                value-key="id"
                @change="handleChange"
              >
                <el-option
                  v-for="p in tasks"
                  :key="p.id"
                  :value="p.title"
                  :label="p.title"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="data.items"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          width="120"
          prop="user_id"
          label="Képviselő id"
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="title"
          label="Időszaki munka neve"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          width="150"
          prop="location"
          label="Terület"
        >
        </el-table-column>

        <el-table-column
          width="150"
          prop="representative_name"
          label="Képviselő"
          show-overflow-tooltip
          fixed
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="shop_id"
          label="Bolt id"
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="shop_name"
          label="Bolt név"
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="postal_code"
          label="Irsz"
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="city"
          label="Település"
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="address"
          show-overflow-tooltip
          label="Cim"
        >
        </el-table-column>

        <el-table-column
          width="120"
          prop="date"
          label="Dátum"
        >
        </el-table-column>

        <template v-if="data.type === 'questionnaire'">
          <el-table-column
            width="200"
            label="Kérdés - válasz"
            v-for="(questionItem, index) in data.items[0].questionnaire"
            :key="index"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.questionnaire[index] !== undefined">
                <b>{{ scope.row.questionnaire[index].question }}</b> <br>
                {{ scope.row.questionnaire[index].answer }}
              </div>
            </template>
          </el-table-column>
        </template>

        <template v-else>
          <el-table-column
            width="120"
            :prop="product.id + '_product'"
            :label="product.name"
            v-for="product in data.products"
            :key="product.id"
          >
          </el-table-column>
        </template>

<!--        <el-table-column-->
<!--          width="100"-->
<!--          prop="commission"-->
<!--          label="Díjazás"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.commission | currency }}-->
<!--          </template>-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--          prop="special_summary"-->
<!--          label="Egyedi áras ért."-->
<!--          width="150"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.special_summary | currency }}-->
<!--          </template>-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--          prop="special_commission"-->
<!--          label="Egyedi áras ért. díjazás"-->
<!--          width="190"-->

<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.special_commission | currency }}-->
<!--          </template>-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--          prop="count"-->
<!--          label="Bruttó mozgóbér"-->
<!--          width="190"-->
<!--          fixed="right"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.commission_summary | currency }}-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('year')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        tasks: [],
        task: null,
        taskLoading: false,
        data: {},
        loading: false,
        downloadLoading: false,
        userLoading: false,
        dateRange: [start, end],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {},
    watch: {},
    async mounted() {
      this.tasks = await axios.get('/api/reports/representative-task/tasks');
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/representative-task/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              // from: this.dateRange[0],
              // to: this.dateRange[1],
              task: this.task,
            },
          });
          saveAs(excel, `representative_task.xlsx`);
        } catch (e) {
        }
        this.downloadLoading = false;
      },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/representative-task?task=${this.task}`
        this.data = await axios.get(query);
        this.loading = false;
      },

      handleChange() {
        this.fetchData();
      }
    },
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
